import { initializeApp } from 'firebase/app'

const firebaseConfig = {
  // apiKey: "AIzaSyDJdYmIygR4tnwGgKCiZmDRxwegOoBPbqo",
  // authDomain: "homebakes-demo.firebaseapp.com",
  // projectId: "homebakes-demo",
  // storageBucket: "homebakes-demo.appspot.com",
  // messagingSenderId: "806603684008",
  // appId: "1:806603684008:web:7c1e69db2683c8bd86aa9d",
  // measurementId: "G-951GDFHR23"

  apiKey: "AIzaSyBC_v4h-rsIePDr3jLlF-QHuhMPcqwYbjk",
  authDomain: "dsrl-dev.firebaseapp.com",
  databaseURL: "https://dsrl-dev-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "dsrl-dev",
  storageBucket: "dsrl-dev.appspot.com",
  messagingSenderId: "430015367329",
  appId: "1:430015367329:web:4534227846b99a768888e0",
  measurementId: "G-BQHK2CBE10"

};

export const app = initializeApp(firebaseConfig)


//!firebase.apps.length? firebase.initializeApp(firebaseConfig) : ''

// export const auth = firebase.auth()
// export default firebase